import { BlogForm } from "./blog__id";

export default function AdminNewBlogPage() {
  return <BlogForm />;
}
